const client = require("@greenlight/optimizely-grpc-client");

function optimizelyGrpc(optimizelyHost, grpcInstance) {
  client.start(optimizelyHost, grpcInstance);

  return client;
}

module.exports = optimizelyGrpc;
